import React from "react";

export const TypingIndicator: React.FC = () => {
  return (
    <div className="flex w-full justify-start">
      <div className="w-full rounded-3xl bg-transparent p-0 pt-1 text-left">
        <div className="flex items-center gap-1.5 px-2 py-3">
          <div className="flex items-center gap-1">
            <span className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground/60" style={{ animationDelay: "0ms" }} />
            <span className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground/60" style={{ animationDelay: "150ms" }} />
            <span className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground/60" style={{ animationDelay: "300ms" }} />
          </div>
          <span className="text-sm text-muted-foreground/70">AI is thinking...</span>
        </div>
      </div>
    </div>
  );
};
